import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQ({ items, title = "Preguntas frecuentes" }) {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section className="py-24 bg-white" data-testid="faq-section">
      <div className="container-max max-w-4xl">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-teal-50 rounded-full px-4 py-1.5 mb-5">
            <span className="text-xs font-semibold text-teal-700 uppercase tracking-wider">FAQ</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">
            {title}
          </h2>
          <p className="text-slate-600">
            Respuestas a las dudas más habituales. ¿No encuentras tu pregunta?{" "}
            <a href="/contacto" className="text-teal-700 underline font-medium">Pregúntanos</a>
          </p>
        </div>

        <div className="space-y-3">
          {items.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border transition-colors ${
                  isOpen ? "border-teal-300 bg-teal-50/40" : "border-slate-200 bg-white"
                }`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-semibold text-slate-900 text-base pr-4">
                    {item.q}
                  </span>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                    isOpen ? "bg-teal-700 text-white" : "bg-slate-100 text-slate-600"
                  }`}>
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </div>
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <div className="px-5 pb-5 text-slate-600 leading-relaxed text-sm">
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
